// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"Loader_loaderOverlay__g4MvN","spinner":"Loader_spinner__wDq1e","spin":"Loader_spin__ddwRw"};